import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Folder from "../assets/images/Folder.svg";
import Document from "./Icons/Document";
import CancelCircle from "./Icons/CancelCircle";
import {EXEL_ERROR_TYPE, HR_ID_COLUMN, MAX_SIZE_IN_BYTES, NAME_COLUMN, VALID_EXEL_FORMAT} from "../constants";
import {ExcelService} from "../services";
import {generateMissingFields, validateHeaders, validateIds} from "../utils";

function ExelFileUpload(props) {
    const hiddenFileInput = React.useRef(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [fieldData, setFieldData] = useState({
        dataFile: null,
    });

    const uploadClick = () => {
        hiddenFileInput.current.click();
    };

    const onReset = (e) => {
        e.stopPropagation();
        setFieldData({
            ...fieldData,
            dataFile: null,
        });
        props.setFieldIsValid(prev => ({
            ...prev,
            isTemplateCheckExcelValid: false,
        }));
        setErrorMessage('');
        props.setExcelFileParsedData([]);
    }

    const fileHandler = async (e) => {
        if (!e.target?.files?.length) {
            return;
        }

        const file = e.target.files[0];
        const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

        if (file.size > MAX_SIZE_IN_BYTES) {
            setErrorMessage('File size exceeds 5Mb.');
            return;
        }

        if (!VALID_EXEL_FORMAT.includes(fileExtension)) {
            setErrorMessage('Incorrect file format.');
            return;
        }

        try {
            const excelFileParsedData = await parseFile(file);
            const requiredFieldsArray = [NAME_COLUMN, HR_ID_COLUMN]?.concat(props.customDymamicFields);
            const checkExcelErrors = validateExcelFile(excelFileParsedData, requiredFieldsArray, props.selectedIds);
            if (checkExcelErrors.type) {
                setFieldData({
                    ...fieldData,
                    dataFile: null,
                });
                props.setFieldIsValid(prev => ({
                    ...prev,
                    isTemplateCheckExcelValid: false,
                }));
                props.setExcelValidationModalInfo(checkExcelErrors);
                props.setExcelFileParsedData([])
            } else {
                setFieldData({
                    ...fieldData,
                    dataFile: file
                });
                props.setFieldIsValid(prev => ({
                    ...prev,
                    isTemplateCheckExcelValid: true,
                }));
                props.setExcelFileParsedData(excelFileParsedData);
            }

            hiddenFileInput.current.value = null;
        } catch (error) {
            setErrorMessage(`Failed to parse file: ${error.message}`);
        }
    }

    const validateExcelFile = (fileData, dynamicFieldsArray, selectedIds) => {
        if (!fileData.length) {
            return {type: EXEL_ERROR_TYPE.EmptyDynamicFields, error: 'Excel file does not contain any dynamic fields.'};
        }

        const headers = Object.keys(fileData[0] || {}).filter(Boolean);
        const errorHeaderValue = validateHeaders(dynamicFieldsArray, headers);

        if (errorHeaderValue) {
            return {type: EXEL_ERROR_TYPE.HeaderError, error: errorHeaderValue};
        }

        const ids = Object.values(fileData.map((item) => item[HR_ID_COLUMN])).filter(Boolean);
        const errorIdsValue = validateIds(selectedIds, ids);

        if (errorIdsValue) {
            return {type: EXEL_ERROR_TYPE.IdsError, error: errorIdsValue};
        }

        const missingFieldsErrorsArray = generateMissingFields(fileData);

        if (missingFieldsErrorsArray.length) {
            return {type: EXEL_ERROR_TYPE.MissedValues, error: missingFieldsErrorsArray};
        }

        return {type: null, error: null};
    };

    const parseFile = async (file) => {
        if (!file) {
            return [];
        }

        const fileExtension = file.name?.slice(file.name.lastIndexOf('.'))?.toLowerCase();

        switch (fileExtension) {
            case '.xlsx':
                return await ExcelService.parseXlsxFile(file);
            case '.csv':
                return await ExcelService.parseCsvFile(file);
            default:
                return Promise.reject(new Error('Unsupported file format.'));
        }
    };

    return (
        <>
            {fieldData.dataFile == null &&
                <Row className={`background-1 file-box file-box-exel mb-5 ${props.isDisabled ? 'disabled' : ''}`}>
                    <Row className="background-1" onClick={uploadClick}>
                        <img src={Folder} alt="Extensis HR" className="icon-upload mb-1"/>
                        <span className="span-upload-label mb-1">Select File To Upload</span>
                        <span className="span-upload mb-1">Allowed file formats: .csv, .xlsx, allowed file size: 5MB</span>
                        {errorMessage && <span className="error-message text-center">{errorMessage}</span>}
                    </Row>
                        <input type="file"
                               accept='.csv, .xlsx'
                               disabled={props.isDisabled}
                               onChange={fileHandler}
                               ref={hiddenFileInput}
                               style={{display: 'none'}}
                        />
                 </Row>
            }
            {fieldData.dataFile !== null &&
                <Row className="background-1 file-box file-box-exel mb-5">
                    <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}>
                        <Row className="background-1" onClick={uploadClick}>
                            <Col lg={{span: 1}} className="doc-icon">
                                <Document className="sidebar-icon"
                                          color="var(--primary-100)"/>
                            </Col>
                            <Col lg={{span: 10}}>
                                <Row className="background-1">
                                    {fieldData.dataFile.name}
                                </Row>
                                <Row className="background-1 doc-size">
                                    File
                                    size: {(Math.round((fieldData.dataFile.size / 1000000) * 100) / 100).toFixed(2)} MB
                                </Row>
                            </Col>
                            <Col lg={{span: 1}} className="doc-icon d-flex justify-content-end" onClick={onReset}>
                                <CancelCircle className="sidebar-icon" color="var(--primary-100)" />
                            </Col>
                        </Row>
                        <input type="file"
                               accept='.csv, .xlsx'
                               onChange={fileHandler}
                               ref={hiddenFileInput}
                               style={{display: 'none'}}
                        />
                    </Col>
                </Row>
            }
        </>
    );
}

export default ExelFileUpload;
